<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/u0CQal/tc-custom/9781455605873.jpg?1738410658454" alt="This image is the cover for the book Hitler Came for Niemoeller"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hitler Came for Niemoeller
      </h1>
      <p class="bookDescription body article font2">
        <p>"To say that this is a good book is to say nothing. To advise one to read it for entertainment is sacrilege. To urge its reading for information, or even for inspiration, is to reveal a lack of insight. This book is a revelation of hell on earth, of the existence of a malignant wickedness and evil in this world. If any man can read it and not be stirred to his depths, it is because he has no depths." --Norman Vincent Peale, from the forewordFirst published in 1942, Leo Stein's account of the imprisonment of Lutheran pastor Martin Niemoeller recounts face-to-face discussions with Hitler. Martin Niemoeller was ordained as a Lutheran pastor in 1924. He was a hero during World War I, a German naval lieutenant and U-boat commander. He was also one of the earliest and most vocal critics of Nazism. As the Third Reich moved toward the obliteration of the Christian Church, Niemoeller, along with other pastors, formed the Pastorï¿½s Emergency League to protect the church and its ministers from imprisonment and destruction. Pastor Niemoellerï¿½s was one of the early, stentorian calls for overseas aid, with a major manifesto appearing in an issue of Time magazine just prior to the 1936 Berlin Olympics. Niemoeller was protected until 1937, when he was found guilty of treason. He was sent for "re-education" and spent the remainder of World War II at Sachsenhausen, Mobait, and Dachau. He lived a life of distinction, serving as president of the World Council of Churches and actively speaking out against nuclear armament and military alliances until his death at age ninety-two in 1984. Leo Stein served as a doctor of jurisprudence and church law and was teaching at the University of Berlin when he was arrested and summarily imprisoned for crimes of treason, his book on the Russian Revolution held as the sole "evidence" against him. This book was written following his emigration to the United States.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Leo Stein
      </h2>
      
      <p class="authorDescription body article">A doctor of jurisprudence and church law, Leo Stein was teaching at the University of Berlin when he was arrested for treason. His book on the Russian Revolution was viewed as proof of his treasonous ways, and Stein was thrown in jail. While in jail, he had an opportunity to observe another prisoner, Martin Niemoeller. Niemoeller, a German pastor, was an early vocal opponent of Nazism.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1ec47ef6